module.exports = __webpack_public_path__ + "img/Delivery-Cost.c8cf6188.jpg";